export enum SttMessageType {
  FocusChange = 'STT_FOCUS_CHANGE',
  Result = 'STT_RESULT',
  RestoreFocus = 'STT_RESTORE_FOCUS'
}
